import React, { useEffect, useState } from "react";
import { Pagination, Spin } from "antd";
import { fetchEntries, changePage } from "../../../redux/slice/entriesSlice";
import { GoBack, HeaderText, MainLayout, Checkbox, ExcelDownloadBtn, PdfDownloadBtn } from "@/components";
import "./tables.scss";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import PDFIcon from "@/assets/images/pdf-file-icon.png";
import { downloadFileTable, getFirstPathSegment } from "../../../services/Utils";

function LeadTableThree() {
  const { rowData, isLoading, totalEntries, pageSize, currentPage } =
    useSelector((state) => state.entries);
  const location = useLocation();
  const pathSegments = location.pathname.split("/");
  const buildingId = pathSegments[pathSegments.length - 1];
  const dispatch = useDispatch();
  const pathName = getFirstPathSegment(location?.pathname);
  const [selectedRows, setSelectedRows] = useState([]);

  useEffect(() => {
    if (buildingId) {
      dispatch(fetchEntries(buildingId));
    }
  }, [buildingId, dispatch]);

  // entries.currentPage is shared by all four lead screens and was never reset,
  // so opening a second building after paging through the first issued
  // skip=<old offset> and rendered an empty table with no error.
  useEffect(() => {
    return () => {
      dispatch(changePage({ page: 1, pageSize: 10 }));
    };
  }, [dispatch]);

  const handlePageChange = (page, size) => {
    dispatch(changePage({ page, pageSize: size }));
    dispatch(fetchEntries(buildingId));
  };

    const handleRowSelection = (id) => {
      setSelectedRows((prev) => {
        if (prev.includes(id)) {
          return prev.filter((rowId) => rowId !== id);
        } else {
          return [...prev, id];
        }
      });
    };
  
    const handleSelectAll = () => {
      if (selectedRows.length === rowData.length) {
        setSelectedRows([]);
      } else {
        setSelectedRows(rowData.map((data) => data.id));
      }
    };
  
    const handleDownloadPDF = async (typeStatus) => {
      const fileName = "Lead_Table_3";
      let type = typeStatus === "xlsx" ? "excel" : "pdf";
      const url = `v1/leadTable/results/${buildingId}/record`;
    
      const data = {
        format: type,
        tableName: "3",
        ...(selectedRows.length > 0 && { docIds: selectedRows }),
      };
    
      await downloadFileTable(typeStatus, url, fileName, data);
    };
  
  return (
    <MainLayout>
      <div className="table-two-wrapper">
        <HeaderText>
          <GoBack />
          Table 3 · <span className="header-light-text">{buildingId}</span>
        </HeaderText>
        <div className="table-wrapper">
          {isLoading ? (
            <Spin delay={20} fullscreen size="large" />
          ) : (
            <div className="table-wrapper">
              <div>
                <div className="d-flex justify-content-end gap-2">
                  <ExcelDownloadBtn onClick={() =>handleDownloadPDF("xlsx")} />
                  <PdfDownloadBtn onClick={() =>handleDownloadPDF("pdf")} />
                </div>
              </div>
              <div
                className="table-overflow-wrapper container p-0"
                id="customScrollTable"
              >
                <table>
                  <thead>
                    <tr>
                      <th>
                        <Checkbox
                          checked={rowData.length > 0 && selectedRows.length === rowData.length}
                          onChange={handleSelectAll}
                        />
                      </th>
                      <th>Test</th>
                      <th>Serial</th>
                      <th>Pass/Fail</th>
                      <th>Unit Type</th>
                      <th>Calibration Model / Matrix ID</th>
                      <th>Display Sigma</th>
                      <th>LOD Sigma</th>
                      <th>Pb</th>
                      <th>Pb +/-</th>
                      <th>Pb P/F</th>
                      <th>Result</th>
                      <th>Lead (mg/cm²)</th>
                      <th>Mode</th>
                      <th>Job #</th>
                      <th>Wall</th>
                      <th>Structure</th>
                      <th>Location</th>
                      <th>Member</th>
                      <th>Paint Condition</th>
                      <th>Substrate</th>
                      <th>Color</th>
                      <th>Room Name</th>
                      <th>Building Type</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rowData.map((data, index) => (
                      <tr key={index}>
                        <td
                          className={
                            selectedRows.includes(data.id) ? "selected-row" : ""
                          }
                        >
                          <Checkbox
                            checked={selectedRows.includes(data.id)}
                            onChange={() => handleRowSelection(data.id)}
                          />
                        </td>
                        <td
                          className={
                            selectedRows.includes(data.id) ? "selected-row" : ""
                          }
                        >
                          {data.TestNumber !== "N/A" &&
                          (data.TestNumber || data.TestNumber === 0)
                            ? data.TestNumber
                            : ""}
                        </td>
                        <td
                          className={
                            selectedRows.includes(data.id) ? "selected-row" : ""
                          }
                        >
                          {data.SerialNumber !== "N/A" &&
                          (data.SerialNumber || data.SerialNumber === 0)
                            ? data.SerialNumber
                            : ""}
                        </td>
                        <td
                          className={
                            selectedRows.includes(data.id) ? "selected-row" : ""
                          }
                        >
                          {data.PassFail !== "N/A" &&
                          (data.PassFail || data.PassFail === 0)
                            ? data.PassFail
                            : ""}
                        </td>
                        <td
                          className={
                            selectedRows.includes(data.id) ? "selected-row" : ""
                          }
                        >
                          {data.UnitType !== "N/A" &&
                          (data.UnitType || data.UnitType === 0)
                            ? data.UnitType
                            : ""}
                        </td>
                        <td
                          className={
                            selectedRows.includes(data.id) ? "selected-row" : ""
                          }
                        >
                          {data.CalibrationModelMatrixID !== "N/A" &&
                          (data.CalibrationModelMatrixID ||
                            data.CalibrationModelMatrixID === 0)
                            ? data.CalibrationModelMatrixID
                            : ""}
                        </td>
                        <td
                          className={
                            selectedRows.includes(data.id) ? "selected-row" : ""
                          }
                        >
                          {data.DisplaySigma !== "N/A" &&
                          (data.DisplaySigma || data.DisplaySigma === 0)
                            ? data.DisplaySigma
                            : ""}
                        </td>
                        <td
                          className={
                            selectedRows.includes(data.id) ? "selected-row" : ""
                          }
                        >
                          {data.LODSigma !== "N/A" &&
                          (data.LODSigma || data.LODSigma === 0)
                            ? data.LODSigma
                            : ""}
                        </td>
                        <td
                          className={
                            selectedRows.includes(data.id) ? "selected-row" : ""
                          }
                        >
                          {data.Pb !== "N/A" && (data.Pb || data.Pb === 0)
                            ? data.Pb
                            : ""}
                        </td>
                        <td
                          className={
                            selectedRows.includes(data.id) ? "selected-row" : ""
                          }
                        >
                          {data.PbPlusMinus !== "N/A" &&
                          (data.PbPlusMinus || data.PbPlusMinus === 0)
                            ? data.PbPlusMinus
                            : ""}
                        </td>
                        <td
                          className={
                            selectedRows.includes(data.id) ? "selected-row" : ""
                          }
                        >
                          {data.PbPassFail !== "N/A" &&
                          (data.PbPassFail || data.PbPassFail === 0)
                            ? data.PbPassFail
                            : ""}
                        </td>
                        <td
                          className={
                            selectedRows.includes(data.id) ? "selected-row" : ""
                          }
                        >
                          {data.Result !== "N/A" &&
                          (data.Result || data.Result === 0)
                            ? data.Result
                            : ""}
                        </td>
                        <td
                          className={
                            selectedRows.includes(data.id) ? "selected-row" : ""
                          }
                        >
                          {data.Lead_mg_cm2 !== "N/A" &&
                          (data.Lead_mg_cm2 || data.Lead_mg_cm2 === 0)
                            ? data.Lead_mg_cm2
                            : ""}
                        </td>
                        <td
                          className={
                            selectedRows.includes(data.id) ? "selected-row" : ""
                          }
                        >
                          {data.Mode !== "N/A" && (data.Mode || data.Mode === 0)
                            ? data.Mode
                            : ""}
                        </td>
                        <td
                          className={
                            selectedRows.includes(data.id) ? "selected-row" : ""
                          }
                        >
                          {data.Job_Number !== "N/A" &&
                          (data.Job_Number || data.Job_Number === 0)
                            ? data.Job_Number
                            : ""}
                        </td>
                        <td
                          className={
                            selectedRows.includes(data.id) ? "selected-row" : ""
                          }
                        >
                          {data.Wall !== "N/A" && (data.Wall || data.Wall === 0)
                            ? data.Wall
                            : ""}
                        </td>
                        <td
                          className={
                            selectedRows.includes(data.id) ? "selected-row" : ""
                          }
                        >
                          {data.Structure !== "N/A" &&
                          (data.Structure || data.Structure === 0)
                            ? data.Structure
                            : ""}
                        </td>
                        <td
                          className={
                            selectedRows.includes(data.id) ? "selected-row" : ""
                          }
                        >
                          {data.Location !== "N/A" &&
                          (data.Location || data.Location === 0)
                            ? data.Location
                            : ""}
                        </td>
                        <td
                          className={
                            selectedRows.includes(data.id) ? "selected-row" : ""
                          }
                        >
                          {data.Member !== "N/A" &&
                          (data.Member || data.Member === 0)
                            ? data.Member
                            : ""}
                        </td>
                        <td
                          className={
                            selectedRows.includes(data.id) ? "selected-row" : ""
                          }
                        >
                          {data.Paint_Condition !== "N/A" &&
                          (data.Paint_Condition || data.Paint_Condition === 0)
                            ? data.Paint_Condition
                            : ""}
                        </td>
                        <td
                          className={
                            selectedRows.includes(data.id) ? "selected-row" : ""
                          }
                        >
                          {data.Substrate !== "N/A" &&
                          (data.Substrate || data.Substrate === 0)
                            ? data.Substrate
                            : ""}
                        </td>
                        <td
                          className={
                            selectedRows.includes(data.id) ? "selected-row" : ""
                          }
                        >
                          {data.Color !== "N/A" &&
                          (data.Color || data.Color === 0)
                            ? data.Color
                            : ""}
                        </td>
                        <td
                          className={
                            selectedRows.includes(data.id) ? "selected-row" : ""
                          }
                        >
                          {data.Room_Name !== "N/A" &&
                          (data.Room_Name || data.Room_Name === 0)
                            ? data.Room_Name
                            : ""}
                        </td>
                        <td
                          className={
                            selectedRows.includes(data.id) ? "selected-row" : ""
                          }
                        >
                          {data.Building_Type !== "N/A" &&
                          (data.Building_Type || data.Building_Type === 0)
                            ? data.Building_Type
                            : ""}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>
        {!isLoading && totalEntries > 0 && totalEntries > 10 && (
          <div className="pagination">
            <Pagination
              current={currentPage}
              total={totalEntries}
              pageSize={pageSize}
              onChange={handlePageChange}
              defaultCurrent={1}
              defaultPageSize={10}
              showSizeChanger
            />
          </div>
        )}
      </div>
    </MainLayout>
  );
}

export default LeadTableThree;
